import React from "react";

const money = (n) =>
  "$" + Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

function Row({ label, value, testid }) {
  return (
    <div className="flex items-center justify-between py-2.5 border-b border-zinc-200">
      <span className="text-sm text-zinc-500">{label}</span>
      <span data-testid={testid} className="font-barlow text-lg font-semibold text-zinc-900">
        {money(value)}
      </span>
    </div>
  );
}

export default function EstimateBreakdown({ estimate }) {
  if (!estimate) return null;
  const li = estimate.line_items;
  const laborWithMargin = (li.labor_cost || 0) + (li.overhead || 0) + (li.profit || 0);
  return (
    <div data-testid="estimate-breakdown">
      <div className="grid grid-cols-3 gap-2 mb-4">
        <Stat label="Roof Area" value={`${estimate.roof_area_sqft.toLocaleString()}`} unit="sq ft" />
        <Stat label="Squares" value={estimate.squares} unit="sq" />
        <Stat label="Waste" value={`${estimate.waste_pct}%`} unit="incl." />
      </div>

      <Row label="Materials (incl. waste)" value={li.material_cost} testid="line-material" />
      <Row label="Labor & Installation" value={laborWithMargin} testid="line-labor" />
      {li.tearoff_cost > 0 && <Row label="Tear-off & Removal" value={li.tearoff_cost} testid="line-tearoff" />}
      {li.disposal_cost > 0 && <Row label="Disposal" value={li.disposal_cost} testid="line-disposal" />}
      <Row label="Permit & Inspection" value={li.permit_cost} testid="line-permit" />
      {li.multi_story_markup > 0 && (
        <Row label="Multi-Story Adjustment (15%)" value={li.multi_story_markup} testid="line-multistory" />
      )}

      <div className="mt-5 bg-zinc-900 border border-zinc-900 p-5">
        <p className="text-xs tracking-[0.2em] uppercase text-zinc-400 font-bold">Total Estimate</p>
        <div className="flex items-end justify-between mt-1">
          <span data-testid="estimate-total" className="font-barlow text-5xl font-black tracking-tighter text-white">
            {money(estimate.total)}
          </span>
          <span className="text-xs text-zinc-400 mb-1">
            {money(estimate.price_per_square)}/sq
          </span>
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, unit }) {
  return (
    <div className="bg-zinc-50 border border-zinc-200 p-3">
      <p className="text-[10px] tracking-wider uppercase text-zinc-500 font-bold">{label}</p>
      <p className="font-barlow text-2xl font-bold text-zinc-900 leading-none mt-1">{value}</p>
      <p className="text-[10px] text-zinc-400">{unit}</p>
    </div>
  );
}
